module.exports = "/images/sophia.png?3aed3a7849eee1cf62fd62514e2cc08f";